import { useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Modal, Form, Input, Radio } from 'antd'
import { searchEmailListAction } from '@/actions/EmailActions'
import useConversationStore from '@/stores/ConversationStore'

const MailListSearchModal = ({ ...props }) => {
  const [currentMailboxOPI] = useConversationStore((state) => [state.currentMailboxOPI])

  const [openForm, setOpenForm] = useState(false)
  const [formSearch] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const onSubmitSearchMailList = async (values) => {
    setLoading(true)
    await searchEmailListAction({...values, opi_sn: currentMailboxOPI});
    setLoading(false)
    setOpenForm(false)
  }
  return (
    <>
      <Button key={'bound'} onClick={() => setOpenForm(true)} size='small' icon={<SearchOutlined className='' />}>
        查找邮件
      </Button>
      <Modal
        width={window.innerWidth < 700 ? '95%' : 960}
        open={openForm}
        cancelText='关闭'
        okText='查找'
        confirmLoading={loading}
        okButtonProps={{ autoFocus: true, htmlType: 'submit', type: 'default' }}
        onCancel={() => setOpenForm(false)}
        footer={null}
        destroyOnHidden
        modalRender={(dom) => (
          <Form
            layout='vertical'
            form={formSearch}
            name='searchmaillist_form_in_modal'
            initialValues={{ mailboxtype: '' }}
            clearOnDestroy
            onFinish={(values) => onSubmitSearchMailList(values)}
            className='[&_.ant-form-item]:m-2'>
            {dom}
          </Form>
        )}>
        <Form.Item name='mailboxtype' label='邮箱文件夹'>
          <Radio.Group
            options={[
              { key: 'All', value: '', label: 'All' },
              { key: '1', value: '1', label: '收件箱' },
              { key: '2', value: '2', label: '未读邮件' },
              { key: '3', value: '3', label: '已发邮件' },
              { key: '7', value: '7', label: '已处理邮件' },
            ]}
            optionType='button'
          />
        </Form.Item>
        <Form.Item name='sender' label='发件人'>
          <Input />
        </Form.Item>
        <Form.Item name='receiver' label='收件人'>
          <Input />
        </Form.Item>
        <Form.Item name='subject' label='主题'>
          <Input />
        </Form.Item>
        <Button type='primary' htmlType='submit' loading={loading}>
          查找
        </Button>
      </Modal>
    </>
  )
}
export default MailListSearchModal
